/**
 * registerSW.js — registers the service worker on the root scope.
 *
 * Imported once from src/index.js. Skipped when running on `localhost` for
 * Create React App dev mode (which would otherwise interfere with HMR).
 */
export function registerServiceWorker() {
  if (typeof window === "undefined") return;
  if (!("serviceWorker" in navigator)) return;

  const host = window.location.hostname;
  const isLocal = host === "localhost" || host === "127.0.0.1";
  if (isLocal && process.env.NODE_ENV !== "production") return;

  // Service worker runs on both preview and production so Web Push works
  // in both environments. `updatefound` + SKIP_WAITING + controllerchange
  // reload keeps builds fresh — no manual hard-refresh needed.

  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js", { scope: "/" })
      .then((reg) => {
        // Auto-activate a new SW once a new version is installed.
        reg.addEventListener("updatefound", () => {
          const installing = reg.installing;
          if (!installing) return;
          installing.addEventListener("statechange", () => {
            if (installing.state === "installed" && navigator.serviceWorker.controller) {
              installing.postMessage({ type: "SKIP_WAITING" });
            }
          });
        });
        // Check for updates every time the tab regains focus — picks up new
        // deploys quickly without the user having to hard-refresh.
        document.addEventListener("visibilitychange", () => {
          if (document.visibilityState === "visible") reg.update();
        });
      })
      .catch(() => {
        /* SW failures are not fatal — app still works without offline. */
      });

    // When the controller actually switches to the new SW, reload once so
    // the user sees the latest build immediately (no stale HTML).
    let reloaded = false;
    navigator.serviceWorker.addEventListener("controllerchange", () => {
      if (reloaded) return;
      reloaded = true;
      window.location.reload();
    });
  });
}
